"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StampMarker = void 0;
var markerjs2_1 = require("markerjs2");
var customStamps_1 = __importDefault(require("./customStamps"));
var StampTypePanel_1 = require("./StampTypePanel");
var StampMarker = /** @class */ (function (_super) {
    __extends(StampMarker, _super);
    function StampMarker(container, overlayContainer, settings) {
        var _this = _super.call(this, container, overlayContainer, settings) || this;
        _this.defaultSize = { x: 48, y: 48 };
        _this.defaultIconSize = 16;
        _this.selectedStamp = null;
        _this.rectangleElement = null;
        _this.strokeColor = settings.defaultColor;
        _this.strokeWidth = settings.defaultStrokeWidth;
        _this.stampTypeSelection = Object.keys(customStamps_1.default)[0];
        _this.colorPickerPanel = new markerjs2_1.ColorPickerPanel('Color', settings.defaultColorSet, _this.strokeColor);
        _this.lineWidthPanel = new markerjs2_1.LineWidthPanel('Line Width', settings.defaultStrokeWidths, _this.strokeWidth);
        _this.stampPanel = new StampTypePanel_1.StampTypePanel('Stamp Type', StampMarker.icon, _this.stampTypeSelection);
        _this.initializeEventHandlers();
        return _this;
    }
    StampMarker.prototype.initializeEventHandlers = function () {
        this.colorPickerPanel.onColorChanged = this.handleColorChange.bind(this);
        this.lineWidthPanel.onWidthChanged = this.handleWidthChange.bind(this);
        this.stampPanel.onStampSelected = this.handleStampSelection.bind(this);
    };
    StampMarker.prototype.handleColorChange = function (newColor) {
        this.strokeColor = newColor;
        this.updateStrokeColor();
    };
    StampMarker.prototype.handleWidthChange = function (newWidth) {
        this.strokeWidth = newWidth;
        this.updateStampPosition();
    };
    StampMarker.prototype.handleStampSelection = function (stampType) {
        this.stampTypeSelection = stampType;
        this.setStampPath();
        this.updateStampPosition();
    };
    StampMarker.prototype.createVisual = function () {
        this.rectangleElement = this.createRectangleElement();
        var translate = markerjs2_1.SvgHelper.createTransform();
        this.setStampPath();
        var markerGroup = markerjs2_1.SvgHelper.createGroup();
        markerGroup.transform.baseVal.appendItem(translate);
        markerGroup.appendChild(this.rectangleElement);
        if (this.selectedStamp) {
            markerGroup.appendChild(this.selectedStamp);
        }
        this.visual = markerGroup;
        this.addMarkerVisualToContainer(this.visual);
        this.updateStampPosition();
    };
    StampMarker.prototype.createRectangleElement = function () {
        return markerjs2_1.SvgHelper.createRect(this.width, this.height, [
            ['stroke', 'transparent'],
            ['fill', 'transparent'],
            ['stroke-width', this.strokeWidth.toString()],
            ['pointer-events', 'all'],
        ]);
    };
    StampMarker.prototype.setStampPath = function () {
        var _a;
        if (this.selectedStamp && this.visual) {
            this.visual.removeChild(this.selectedStamp);
        }
        if (this.stampTypeSelection) {
            this.selectedStamp = customStamps_1.default[this.stampTypeSelection].path(this.strokeColor, 1);
            if (this.selectedStamp) {
                markerjs2_1.SvgHelper.setAttributes(this.selectedStamp, [['fill', this.strokeColor]]);
            }
            (_a = this.visual) === null || _a === void 0 ? void 0 : _a.appendChild(this.selectedStamp);
            this.updateStampPosition();
        }
    };
    StampMarker.prototype.updateStampPosition = function () {
        if (!this.selectedStamp)
            return;
        var scaleX = this.width / this.defaultIconSize;
        var scaleY = this.height / this.defaultIconSize;
        markerjs2_1.SvgHelper.setAttributes(this.selectedStamp, [['transform', "scale(".concat(scaleX, ", ").concat(scaleY, ")")]]);
        this.updateStrokeWidth(Math.min(scaleX, scaleY));
    };
    StampMarker.prototype.updateStrokeColor = function () {
        if (!this.selectedStamp)
            return;
        markerjs2_1.SvgHelper.setAttributes(this.selectedStamp, [
            ['stroke', this.strokeColor],
            ['fill', this.strokeColor],
        ]);
    };
    StampMarker.prototype.updateStrokeWidth = function (scaleFactor) {
        if (scaleFactor === void 0) { scaleFactor = 1; }
        if (!this.selectedStamp)
            return;
        var adjustedWidth = this.strokeWidth / scaleFactor;
        markerjs2_1.SvgHelper.setAttributes(this.selectedStamp, [['stroke-width', adjustedWidth.toString()]]);
    };
    StampMarker.prototype.setSize = function () {
        _super.prototype.setSize.call(this);
        if (!this.rectangleElement)
            return;
        markerjs2_1.SvgHelper.setAttributes(this.rectangleElement, [
            ['width', this.width.toString()],
            ['height', this.height.toString()],
        ]);
        this.updateStampPosition();
    };
    StampMarker.prototype.moveVisual = function (point) {
        if (!this.visual)
            return;
        var translate = this.visual.transform.baseVal.getItem(0);
        translate.setTranslate(point.x, point.y);
        this.visual.transform.baseVal.replaceItem(translate, 0);
    };
    StampMarker.prototype.pointerDown = function (point, target) {
        _super.prototype.pointerDown.call(this, point, target);
        if (this.state === 'new') {
            this.initializeNewMarker(point);
        }
        this.setSize();
    };
    StampMarker.prototype.initializeNewMarker = function (point) {
        // start with a 1x1 marker to work with resizes
        this.width = 1;
        this.height = 1;
        this.createVisual();
        this.setSize();
        this._state = 'creating';
    };
    StampMarker.prototype.pointerUp = function (point) {
        _super.prototype.pointerUp.call(this, point);
        this.setSize();
    };
    Object.defineProperty(StampMarker.prototype, "toolboxPanels", {
        get: function () {
            return [this.colorPickerPanel, this.lineWidthPanel, this.stampPanel];
        },
        enumerable: false,
        configurable: true
    });
    StampMarker.prototype.ownsTarget = function (el) {
        var _a, _b, _c;
        return (_super.prototype.ownsTarget.call(this, el) ||
            ((_a = this.visual) === null || _a === void 0 ? void 0 : _a.contains(el)) ||
            ((_b = this.rectangleElement) === null || _b === void 0 ? void 0 : _b.contains(el)) ||
            ((_c = this.selectedStamp) === null || _c === void 0 ? void 0 : _c.contains(el)));
    };
    StampMarker.prototype.getState = function () {
        return __assign(__assign({}, _super.prototype.getState.call(this)), { stampType: this.stampTypeSelection, strokeColor: this.strokeColor, strokeWidth: this.strokeWidth, fillColor: 'transparent', strokeDasharray: 'none', opacity: 1, typeName: StampMarker.typeName });
    };
    StampMarker.prototype.restoreState = function (state) {
        var smState = state;
        this.strokeColor = smState.strokeColor;
        this.strokeWidth = smState.strokeWidth;
        this.stampTypeSelection = smState.stampType;
        this.height = smState.height;
        this.width = smState.width;
        this.createVisual();
        _super.prototype.restoreState.call(this, state);
        this.setSize();
    };
    StampMarker.typeName = 'StampMarker';
    StampMarker.title = 'Stamp';
    StampMarker.icon = customStamps_1.default.stampMark.icon;
    return StampMarker;
}(markerjs2_1.RectangularBoxMarkerBase));
exports.StampMarker = StampMarker;
